import { render, staticRenderFns } from "./add-doctor.vue?vue&type=template&id=7504eee8&scoped=true&"
import script from "./add-doctor.vue?vue&type=script&lang=js&"
export * from "./add-doctor.vue?vue&type=script&lang=js&"
import style0 from "./add-doctor.vue?vue&type=style&index=0&id=7504eee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504eee8",
  null
  
)

export default component.exports